import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { getActiveLanguage } from 'react-localize-redux';

import MicroFrontend from '@fd/ui/MicroFrontend/MicroFrontend';

import { dateTimeUtils } from '../../selectors/localeDateTime.selector';

const PRODUCTION_PORTAL_HOST = 'portal.flipdish.com';

const isProductionPortalHost = (hostname: string) =>
  hostname === PRODUCTION_PORTAL_HOST || hostname.endsWith(`.${PRODUCTION_PORTAL_HOST}`);

type ClientReportingMicroFrontendProps = {
  // The portal section the MFE mounts under, e.g. `finance` for payouts or `reports` for dashboards.
  portalSection: string;
  dataFd: string;
};

export const ClientReportingMicroFrontend = ({
  portalSection,
  dataFd,
}: ClientReportingMicroFrontendProps) => {
  const currentApp = useAppSelector((state) => state.currentApp);
  const languageCode = useAppSelector((state) => getActiveLanguage(state.locale));
  const timezone = useAppSelector((state) => {
    const dtUtils = dateTimeUtils(state);
    return dtUtils.userIanaTimeZone || dtUtils.systemIanaTimeZone || '';
  });

  const partialIndexUrl = isProductionPortalHost(window.location?.hostname ?? '')
    ? 'https://clients.portal-mfs.flipdish.com/client-reporting/production'
    : 'https://clients-integration.portal-mfs.flipdishdev.com/client-reporting/prod-staging';

  const appId = currentApp?.AppId ?? '';

  return (
    <MicroFrontend
      partialIndexUrl={partialIndexUrl}
      microFrontendWindowName="client-reporting"
      language={languageCode}
      portalBaseUrl={`/${appId}/${portalSection}`}
      enableManifestFile={true}
      otherProps={{
        'data-fd': dataFd,
        'data-language': languageCode || 'en',
        'data-timezone': timezone,
      }}
    />
  );
};

export const ClientReportingPayoutsMFE = () => (
  <ClientReportingMicroFrontend portalSection="finance" dataFd="client-reporting-micro-frontend" />
);

export default ClientReportingPayoutsMFE;
